<template lang="pug">
div(v-if="!block")
LazyExperiment(
    v-else-if="patternCheck(block.attributes, EXPERIMENT) && block.experiment === undefined"
    :block="block"
    :lazy="lazy")
OptimizedSource(
  v-else-if="blockId.includes('source') && block.tagName && block.type === CORE_IMAGE && getImageData.url"
  :image-data="getImageData"
  :media="blockId.split('_')[1]"
  :lazy="lazy")
OptimizedImage(
  v-else-if="blockId.includes('img') && block.tagName && block.type === CORE_IMAGE && getImageData.url"
  :image-data="getImageData"
  :block="block"
  :block-id="blockId.split('_')[1]"
  :media="blockId.split('_')[2]"
  :lazy="lazy")
figure(
  v-else-if="block.tagName && block.type === CORE_IMAGE && getImageData.url"
  v-bind="getAttributes(block)"
  :class="[attributeClasses, 'overflow-hidden']")
  OptimizedImage(
    :image-data="getImageData"
    :block="block"
    :block-id="blockId"
    :lazy="lazy")
  figcaption(v-if="imageCaption") {{imageCaption}}
div(
  v-else-if="block.tagName && block.type === CORE_IMAGE"
  :class="attributeClasses")
  CoreBlock(
    v-if="block.tagName"
    :block="block")
a(
  v-else-if="block.tagName && block.type === CORE_PARAGRAPH && isLinkOnly(block.innerHtml)"
  :href="getHref(block.innerHtml)"
  :class="getLinkClass(block)") {{getLink(block.innerHtml)}}
ResponsiveImageSet(
  v-else-if="patternCheck(block.attributes, RESPONSIVE_IMAGE_SET)"
  :block="block"
  :block-id="blockId")
LazyValueAddSection(
  v-else-if="patternCheck(block.attributes, VALUE_ADD_SECTION)"
  :block="block"
  :lazy="lazy")
LazyOtherServicesSection(
  v-else-if="patternCheck(block.attributes, OTHER_SERVICES_SECTION)"
  :block="block"
  :lazy="lazy")
LazyImageText(
  v-else-if="patternCheck(block.attributes, IMAGE_TEXT_SECTION)"
  :block="block"
  :lazy="lazy")
LazyAvIconTable(
  v-else-if="patternCheck(block.attributes, ICON_TABLE)"
  :block="block"
  :lazy="lazy")
LazyAvLinkTable(
  v-else-if="patternCheck(block.attributes, LINK_TABLE)"
  :block="block"
  :lazy="lazy")
LazyAvCheckList(
  v-else-if="patternCheck(block.attributes, CHECK_LIST)"
  :block="block"
  :lazy="lazy")
LazyPriceBanner(
  v-else-if="patternCheck(block.attributes, PRICE_BANNER)"
  :block="block"
  :lazy="lazy")
LazyImageOverlay(
  v-else-if="patternCheck(block.attributes, IMAGE_OVERLAY)"
  :block="block"
  :lazy="lazy")
LazyFaqSection(
  v-else-if="patternCheck(block.attributes, FAQ_SECTION)"
  :block="block"
  :lazy="lazy")
LazyRebrandHeader(
  v-else-if="patternCheck(block.attributes, HEADER)"
  :block="block"
  :block-id="blockId"
  :lazy="lazy"
  :isPPC="isPPC")
LazyHomePageHeader(
  v-else-if="patternCheck(block.attributes, HOME_PAGE_HEADER)"
  :block="block"
  :lazy="lazy")
LazyHeaderCards(
  v-else-if="patternCheck(block.attributes, HEADER_CARDS) && $i18n.locale === 'en'"
  :lazy="lazy")
LazyHeaderCardsUS(
  v-else-if="patternCheck(block.attributes, HEADER_CARDS) && $i18n.locale === 'us'"
  :lazy="lazy")
LazyHeaderCardsES(
  v-else-if="patternCheck(block.attributes, HEADER_CARDS) && $i18n.locale === 'es'"
  :lazy="lazy")
LazyHeaderCardsFR(
  v-else-if="patternCheck(block.attributes, HEADER_CARDS) && $i18n.locale === 'fr'"
  :lazy="lazy")
LazyHeaderCardsDE(
  v-else-if="patternCheck(block.attributes, HEADER_CARDS) && $i18n.locale === 'de'"
  :lazy="lazy")
LazyRecentMovesSection(
  v-else-if="patternCheck(block.attributes, RECENT_MOVES_SECTION)"
  :block="block"
  :block-id="blockId"
  :lazy="lazy")
LazyComparisonTable(
  v-else-if="patternCheck(block.attributes, COMPARISON_TABLE_ITEM)"
  :block="block"
  :lazy="lazy")
LazyFurnitureForm(
  v-else-if="patternCheck(block.attributes, LOCATION_FORM)"
  :category-v4-id="CATEGORY_V4_ID_FURNITURE"
  :has-extension="patternCheck(block.attributes, LOCATION_FORM_EXTENSION)"
  :block="block"
  :lazy="lazy")
LazyFurnitureForm(
  v-else-if="patternCheck(block.attributes, PIANO_FORM) && $i18n.locale === 'es'"
  :category-v4-id="CATEGORY_V4_ID_PIANO"
  :has-extension="patternCheck(block.attributes, LOCATION_FORM_EXTENSION)"
  :block="block"
  :lazy="lazy")
LazyFurnitureForm(
  v-else-if="patternCheck(block.attributes, CAR_FORM) && $i18n.locale === 'es'"
  :category-v4-id="CATEGORY_V4_ID_CAR"
  :has-extension="patternCheck(block.attributes, LOCATION_FORM_EXTENSION)"
  :block="block"
  :lazy="lazy")
LazyCarForm(
  v-else-if="patternCheck(block.attributes, AV_CAR_FORM)"
  :block="block")
LazyStorageForm(
  v-else-if="patternCheck(block.attributes, AV_STORAGE_FORM)"
  :block="block"
  :lazy="lazy")
LazyRemovalsLocationForm(
  v-else-if="patternCheck(block.attributes, REMOVALS_FORM)"
  :block="block"
  :lazy="lazy")
LazyCtaForm(
  v-else-if="patternCheck(block.attributes, CTA_FORM)"
  :block="block"
  :lazy="lazy")
LazyLocationFormExtension(
  v-else-if="patternCheck(block.attributes, LOCATION_FORM_EXTENSION)"
  :block="block"
  :block-id="blockId"
  :lazy="lazy")
LazyPropositionMessaging(
  v-else-if="patternCheck(block.attributes, PROPOSITION_MESSAGING)"
  :block="block"
  :lazy="lazy")
LazyInternalReviews(
  v-else-if="patternCheck(block.attributes, INTERNAL_REVIEWS)"
  :block="block"
  :lazy="lazy")
LazyInternalReviewSection(
  v-else-if="patternCheck(block.attributes, INTERNAL_REVIEW_SECTION) && $i18n.locale === 'en'"
  :block="block")
LazyInternalReviewSection(
  v-else-if="patternCheck(block.attributes, INTERNAL_REVIEW_SECTION) && $i18n.locale === 'es'"
  :block="block")
LazyInternalReviewSectionUS(
  v-else-if="patternCheck(block.attributes, INTERNAL_REVIEW_SECTION) && $i18n.locale === 'us'"
  :block="block")
LazyDIYBreadcrumb(
  v-else-if="patternCheck(block.attributes, BREADCRUMB)"
  :block="block")
LazyTrustpilotCarousel(
  v-else-if="patternCheck(block.attributes, TRUSTPILOT_CAROUSEL)"
  :block="block"
  :block-id="blockId")
LazyCarouselSwiper(
  v-else-if="patternCheck(block.attributes, CAROUSEL_SWIPER)"
  :block="block"
  :block-id="blockId"
  :flush-image="patternCheck(block.attributes, 'av-flush-image')"
  :lazy="true")
LazyTrustPilotWidget(v-else-if="patternCheck(block.attributes, TRUSTPILOT_WIDGET)")
LazyImageDialog(
  v-else-if="patternCheck(block.attributes, IMAGE_DIALOG)"
  :block="block")
LazyAvLocalSummary(
  v-else-if="patternCheck(block.attributes, AV_LOCAL_SUMMARY)"
  :block="block")
LazyCoreCover(
  v-else-if="block.type === CORE_COVER"
  :block="block"
  :virgin="virgin"
  :lazy="lazy")
  Block(
    v-for="(innerBlock, key) in block.innerBlocks"
    :key="`innerBlock${key}`"
    :block="innerBlock"
    :block-id="blockId")
LazyAvLinkPhone(
  v-else-if="patternCheck(block.attributes, LINK_PHONE)"
  :link-only="patternCheck(block.attributes, LINK_PHONE_LINK_ONLY)"
  :block="block")
LazyLeafletLocalMovesMap(
  v-else-if="patternCheck(block.attributes, LEAFLET_LOCAL_MOVES_MAP)"
  :block="block")
LazyMapboxLocalMoves(
  v-else-if="patternCheck(block.attributes, MAPBOX_LOCAL_MOVES_MAP)"
  :block="block")
LazyPanelCTAs(
  v-else-if="patternCheck(block.attributes, MAP_PANEL_CTAS)"
  :block="block")
LazyMediaTextResponsive(
  v-else-if="patternCheck(block.attributes, MEDIA_TEXT_RESPONSIVE)"
  :block="block"
  :dynamic-content="patternCheck(block.attributes, AV_DYNAMIC_CONTENT)"
  :lazy="lazy")
LazyServiceHighlight(
  v-else-if="patternCheck(block.attributes, SERVICE_HIGHLIGHT)"
  :block="block"
  lazy)
LazyGoLocalHeader(
  v-else-if="patternCheck(block.attributes, GO_LOCAL_HEADER)"
  :block="block")
LazyGoLocalAccountManager(
  v-else-if="patternCheck(block.attributes, GO_LOCAL_ACCOUNT_MANAGER)"
  :block="block")
LazyGoLocalReviewSection(
  v-else-if="patternCheck(block.attributes, GO_LOCAL_REVIEWS)"
  :block="block")
LazyBackgroundImage(
  v-else-if="patternCheck(block.attributes, AV_BACKGROUND_IMAGE)"
  :block="block"
  lazy)
LazyAvWhatsappButton(
  v-else-if="patternCheck(block.attributes, AV_WHATSAPP_BUTTON)"
  :block="block")
LazyAvTable(
  v-else-if="patternCheck(block.attributes, AV_TABLE)"
  :block="block"
)
LazySitemap(
  v-else-if="patternCheck(block.attributes, SITEMAP)"
  :block="block"
)
LazySimilarAISection(
  v-else-if="patternCheck(block.attributes, SIMILAR_AI_SECTION)"
  :block="block"
)
WrapperBlock(
  v-else-if="block.innerBlocks.length && depth < 10"
  :block="block"
  :block-id="blockId"
  :virgin="virgin"
  :lazy="lazy"
  :isRebrand="isRebrand"
  :depth="depth + 1")
div(
  v-else-if="block.type === CORE_BUTTON && attributeClasses.includes('phone-number')"
  :class="$style.phoneFullWidth")
  PhoneNumber(
    :class="[attributeClasses, $style.fullBtnPhone]"
    :showIcon="true"
    icon="i:telephone"
    :showText="true"
    :showButton="false"
    :inheritColor="true"
    :inheritFontSize="true"
    linkClass="button-link wp-block-button__link wp-element-button"
    :phone="phoneNumber")
  PhoneNumber(
    :class="[attributeClasses, $style.btnPhone]"
    :showButton="true"
    :showButtonText="true"
    :inheritColor="true"
    buttonText="Give us a call"
    linkClass="button-link wp-block-button__link wp-element-button"
    :phone="phoneNumber")
CoreBlock(
  v-else
  :block="block")
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { getAttributes, getAttribute, patternCheck } from "~/utils/block"
import {
  CATEGORY_V4_ID_FURNITURE,
  CATEGORY_V4_ID_HOUSE_MOVE,
  CATEGORY_V4_ID_PIANO,
  CATEGORY_V4_ID_CAR
} from "~/constants/category"
import {
  CHECK_LIST,
  COMPARISON_TABLE_ITEM,
  CORE_BUTTON,
  CORE_COVER,
  CORE_IMAGE,
  CORE_PARAGRAPH,
  FAQ_SECTION,
  HEADER,
  HOME_PAGE_HEADER,
  ICON_TABLE,
  IMAGE_DIALOG,
  IMAGE_OVERLAY,
  IMAGE_TEXT_SECTION,
  INTERNAL_REVIEWS,
  INTERNAL_REVIEW_SECTION,
  LINK_PHONE,
  LINK_PHONE_LINK_ONLY,
  LINK_TABLE,
  REMOVALS_FORM,
  CTA_FORM,
  LOCATION_FORM,
  LOCATION_FORM_EXTENSION,
  PIANO_FORM,
  CAR_FORM,
  AV_CAR_FORM,
  AV_STORAGE_FORM,
  OTHER_SERVICES_SECTION,
  PRICE_BANNER,
  RECENT_MOVES_SECTION,
  RESPONSIVE_IMAGE_SET,
  TRUSTPILOT_CAROUSEL,
  CAROUSEL_SWIPER,
  VALUE_ADD_SECTION,
  TRUSTPILOT_WIDGET,
  HEADER_CARDS,
  MEDIA_TEXT_RESPONSIVE,
  EXPERIMENT,
  LEAFLET_LOCAL_MOVES_MAP,
  MAPBOX_LOCAL_MOVES_MAP,
  MAP_PANEL_CTAS,
  AV_LOCAL_SUMMARY,
  SERVICE_HIGHLIGHT,
  GO_LOCAL_HEADER,
  GO_LOCAL_ACCOUNT_MANAGER,
  GO_LOCAL_REVIEWS,
  BREADCRUMB,
  AV_BACKGROUND_IMAGE,
  AV_DYNAMIC_CONTENT,
  AV_WHATSAPP_BUTTON,
  AV_TABLE,
  PROPOSITION_MESSAGING,
  SITEMAP,
  SIMILAR_AI_SECTION
} from "~/constants/blocks"

interface ImageData {
  id: string | null
  url: string | null
  width?: number
  height?: number
}

export default defineComponent({
  name: "Block",

  props: {
    block: {
      type: Object as () => Block,
      required: true
    },
    blockId: {
      type: String,
      default: ""
    },
    virgin: {
      type: Boolean
    },
    lazy: {
      type: Boolean
    },
    isRebrand: {
      type: Boolean
    },
    isPPC: {
      type: Boolean
    },
    depth: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      CHECK_LIST,
      COMPARISON_TABLE_ITEM,
      CORE_BUTTON,
      CORE_COVER,
      CORE_IMAGE,
      CORE_PARAGRAPH,
      FAQ_SECTION,
      HEADER,
      HOME_PAGE_HEADER,
      ICON_TABLE,
      IMAGE_DIALOG,
      IMAGE_OVERLAY,
      IMAGE_TEXT_SECTION,
      INTERNAL_REVIEWS,
      INTERNAL_REVIEW_SECTION,
      LINK_PHONE,
      LINK_PHONE_LINK_ONLY,
      LINK_TABLE,
      REMOVALS_FORM,
      CTA_FORM,
      LOCATION_FORM,
      LOCATION_FORM_EXTENSION,
      PIANO_FORM,
      CAR_FORM,
      AV_CAR_FORM,
      AV_STORAGE_FORM,
      OTHER_SERVICES_SECTION,
      PRICE_BANNER,
      RECENT_MOVES_SECTION,
      RESPONSIVE_IMAGE_SET,
      TRUSTPILOT_CAROUSEL,
      CAROUSEL_SWIPER,
      VALUE_ADD_SECTION,
      TRUSTPILOT_WIDGET,
      HEADER_CARDS,
      MEDIA_TEXT_RESPONSIVE,
      EXPERIMENT,
      LEAFLET_LOCAL_MOVES_MAP,
      MAPBOX_LOCAL_MOVES_MAP,
      MAP_PANEL_CTAS,
      AV_LOCAL_SUMMARY,
      SERVICE_HIGHLIGHT,
      GO_LOCAL_HEADER,
      GO_LOCAL_ACCOUNT_MANAGER,
      GO_LOCAL_REVIEWS,
      BREADCRUMB,
      AV_BACKGROUND_IMAGE,
      AV_DYNAMIC_CONTENT,
      CATEGORY_V4_ID_FURNITURE,
      CATEGORY_V4_ID_PIANO,
      CATEGORY_V4_ID_CAR,
      CATEGORY_V4_ID_HOUSE_MOVE,
      AV_WHATSAPP_BUTTON,
      AV_TABLE,
      SITEMAP,
      PROPOSITION_MESSAGING,
      SIMILAR_AI_SECTION
    }
  },

  computed: {
    phoneNumber(): string | null {
      const phoneNumberMatch = this.block.innerHtml.match(/<a[^>]*>+(.*)<\/a>/)
      return phoneNumberMatch ? phoneNumberMatch[1] : null
    },

    imageId(): string | null {
      const imageId = this.block.attributes.find(attribute => attribute.name === "id")
      return imageId ? imageId.value : null
    },

    imageUrl(): string | null {
      if (!this.block.innerHtml) {
        return null
      }

      const regex = /src="([^"]+)"/
      const src = regex.exec(this.block.innerHtml)

      if (src) {
        return src[1]
      }

      console.warn("The page includes image without source!")
      return null
    },

    attributeClasses(): string {
      return this.getAttributes(this.block).class
    },

    getImageData(): ImageData {
      const imageData: ImageData = {
        id: this.imageId,
        url: this.imageUrl
      }

      const width = this.getAttribute(this.block.attributes, "width")
      const height = this.getAttribute(this.block.attributes, "height")

      if (width && height) {
        Object.assign(imageData, { width, height })
      }

      return imageData
    },

    imageCaption(): string | null {
      const regex = /<figcaption>([^"]+)<\/figcaption>/
      const caption = regex.exec(this.block.innerHtml)

      return caption ? caption[1] : null
    }
  },

  methods: {
    getAttributes,
    getAttribute,
    patternCheck,

    isLinkOnly(innerHtml: string): boolean {
      const pHtml = innerHtml.replace(/<a[^>]*>(.+?)<\/a>/, "")
      const pText = pHtml.replace(/<p[^>]*>(.+?)<\/p>/, "$1")
      return !pText
    },

    getHref(innerHtml: string): string {
      const hrefArray = /href="([^'"]+)/g.exec(innerHtml)
      return hrefArray ? hrefArray[1] : ""
    },

    getLink(innerHtml: string): string {
      return innerHtml.replace(/(<([^>]+)>)/gi, "")
    },

    getLinkClass(block: Block): string | undefined {
      const attributes = this.getAttributes(block)
      return attributes.class?.replace("av-paragraph ", "")
    }
  }
})
</script>

<style lang="scss" module>
:global .av-buttons .av-button {
  @apply p-0; /* Unset DS Button padding */
  border-radius: 6px;
  display: inline-block;
  margin-top: 30px;

  &:hover {
    filter: brightness(85%);
  }

  &.btn-primary,
  &.bg-primary {
    background-color: #41a5dd;
    color: #ffffff;
    text-align: center;
    font-weight: 700;

    &:hover {
      filter: none;
      background-color: #1e4c71;
    }
  }

  &.btn-critical,
  &.bg-critical {
    text-align: center;

    &:hover {
      filter: none;
      background-color: #da0a24;
    }
  }

  &.btn-anyvan-cta-primary,
  &.bg-anyvan-cta-primary {
    &:hover {
      filter: none;
      @apply bg-pink-600;
    }
  }

  &.btn-petrol-blue,
  &.bg-petrol-blue {
    &:hover {
      filter: none;
      background-color: #285aa9;
    }
  }

  &.bg-white {
    &:hover {
      filter: none;
      color: #ffffff;
      background-color: #41a5dd;
    }
  }

  &.btn-secondary {
    background-color: transparent;
    color: #292929;
    -webkit-box-shadow: inset 0px 0px 0px 2px #292929;
    -moz-box-shadow: inset 0px 0px 0px 2px #292929;
    box-shadow: inset 0px 0px 0px 2px #292929;
    text-align: center;
    font-weight: 700;

    &-white {
      @extend .btn-secondary;
      color: #ffffff;
      -webkit-box-shadow: inset 0px 0px 0px 2px #ffffff;
      -moz-box-shadow: inset 0px 0px 0px 2px #ffffff;
      box-shadow: inset 0px 0px 0px 2px #ffffff;
    }

    &:hover {
      filter: none;
      background-color: #41a5dd;
      color: #ffffff;
      -webkit-box-shadow: none;
      -moz-box-shadow: none;
      box-shadow: none;
    }
  }
}

.btnPhone {
  @apply self-center;

  a {
    @apply inline-block h-auto border-none;
  }

  @media (min-width: var(--breakpoint-md)) {
    @apply hidden;
  }
}

.fullBtnPhone {
  @apply self-center hidden mt-ds-lg;

  a {
    @apply h-auto border-none items-center justify-center gap-ds-sm;
  }

  @media (min-width: var(--breakpoint-md)) {
    @apply flex;
  }
}

.phoneFullWidth {
  @apply w-full;

  @screen md {
    @apply w-auto;
  }
}

@screen md {
  :global {
    .layout-container {
      .removals-hub-hero,
      .cover-text-cta {
        .av-buttons.phone-number-buttons {
          @apply flex-wrap gap-x-ds-lg w-full;
        }
      }
    }
  }
}

:global .wp-block-button__link {
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 15px 30px;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 15.11px;
  line-height: 25px;
  align-items: center;
  text-align: center;
  letter-spacing: 0.6px;
  color: inherit;
  cursor: pointer;
  display: inline-block;

  &:hover {
    text-decoration: none;
    color: inherit;
  }
}
</style>
